<div class="mct-flex mct-col mct-gap-27" *ngIf="pledge" ngModelGroup="pledge">
  <div class="mct-grid mct-cols-1-1 mct-grid-lt-md mct-cols-1-lt-md mct-gap-20 pledge-details-grid">
    <div class="area-header">
      <span class="section-header area-header">{{ 'revenue.pledge.edit.details.title' | translate | titlecase }}</span>
    </div>

    <div class="area-left-fields">
      <div class="mb-20">
        <label class="light-text">{{ 'revenue.pledge.edit.details.start-date' | translate | titlecase }}</label>
        <wl-date-selector appendTo="body" [required]="true" name="startDate" [(ngModel)]="pledge.StartDate"></wl-date-selector>
      </div>
      <div class="mb-20">
        <label class="light-text">{{ 'revenue.pledge.edit.details.end-date' | translate | titlecase }}</label>
        <wl-date-selector appendTo="body" [required]="true" name="endDate" [(ngModel)]="pledge.EndDate"></wl-date-selector>
      </div>
      <div class="w-100 mb-20 mct-flex mct-col">
        <label class="light-text">{{ 'revenue.pledge.edit.details.pledge-amount-total' | translate | titlecase }}</label>
        <div class="p-inputgroup">
          <span class="atlas-input-addon">$</span>
          <p-inputNumber
            required
            name="pledgeAmountTotal"
            [(ngModel)]="pledge.PledgeTotal"
            showClear="true"
            mode="decimal"
            [style]="{ width: '100%' }"
            [min]="0"
          ></p-inputNumber>
        </div>
      </div>
      <div class="w-100 mct-flex mct-col">
        <label class="light-text">{{ 'revenue.pledge.edit.details.pledge-years' | translate | titlecase }}</label>
        <p-inputNumber
          name="pledgeYears"
          [(ngModel)]="pledge.PledgeYears"
          showClear="true"
          [style]="{ width: '100%' }"
          [min]="0"
        ></p-inputNumber>
      </div>
    </div>

    <div class="area-right-fields">
      <div class="mb-20">
        <label class="light-text">{{ 'revenue.pledge.edit.details.pledge-level' | translate | titlecase }}</label>
        <p-select
          appendTo="body"
          name="pledgeLevel"
          [(ngModel)]="pledge.PledgeLevel"
          [options]="pledgeLevels"
          showClear
          [placeholder]="'revenue.pledge.edit.details.pledge-level-placeholder' | translate | titlecase"
          [style]="{ width: '100%' }"
        ></p-select>
      </div>
      <div class="mb-20">
        <label class="light-text">{{ 'revenue.pledge.edit.details.revenue-item' | translate | titlecase }}</label>
        <p-select
          appendTo="body"
          name="revenueItem"
          [(ngModel)]="pledge.ItemNum"
          [options]="revItems"
          showClear
          [placeholder]="'revenue.pledge.edit.details.revenue-item-placeholder' | translate | titlecase"
          [style]="{ width: '100%' }"
        ></p-select>
      </div>
      <div class="mb-20">
        <label class="light-text">{{ 'revenue.pledge.edit.details.billing-cycle' | translate | titlecase }}</label>
        <p-select
          appendTo="body"
          name="billingCycle"
          [(ngModel)]="pledge.BillingCycle"
          [options]="billCycles"
          showClear
          [placeholder]="'revenue.pledge.edit.details.billing-cycle-placeholder' | translate | titlecase"
          [style]="{ width: '100%' }"
        ></p-select>
      </div>
      <div>
        <label class="light-text">{{ 'revenue.pledge.edit.details.assigned-to' | translate | titlecase }}</label>
        <p-select
          appendTo="body"
          name="assignedTo"
          [(ngModel)]="pledge.AssignedTo"
          [options]="activeUsers"
          showClear
          [placeholder]="'revenue.pledge.edit.details.assigned-to-placeholder' | translate | titlecase"
          [style]="{ width: '100%' }"
        ></p-select>
      </div>
    </div>

    <div class="area-note-field">
      <div>
        <label class="light-text">{{ 'revenue.pledge.edit.details.notes' | translate | titlecase }}</label>
        <textarea pInputTextarea [(ngModel)]="pledge.Notes" name="notes"></textarea>
      </div>
    </div>

    <div class="area-custom-left-fields">
      <div class="mb-20">
        <label class="light-text">{{ 'revenue.pledge.edit.details.custom1' | translate | titlecase }}</label>
        <input pInputText name="custom1" [(ngModel)]="pledge.Custom1" />
      </div>
      <div class="mb-20">
        <label class="light-text">{{ 'revenue.pledge.edit.details.custom3' | translate | titlecase }}</label>
        <input pInputText name="custom3" [(ngModel)]="pledge.Custom3" />
      </div>
      <div class="mb-20">
        <label class="light-text">{{ 'revenue.pledge.edit.details.custom5' | translate | titlecase }}</label>
        <input pInputText name="custom5" [(ngModel)]="pledge.Custom5" />
      </div>
    </div>

    <div class="area-custom-right-fields">
      <div class="mb-20">
        <label class="light-text">{{ 'revenue.pledge.edit.details.custom2' | translate | titlecase }}</label>
        <input pInputText name="custom2" [(ngModel)]="pledge.Custom2" />
      </div>
      <div class="mb-20">
        <label class="light-text">{{ 'revenue.pledge.edit.details.custom4' | translate | titlecase }}</label>
        <input pInputText name="custom4" [(ngModel)]="pledge.Custom4" />
      </div>
    </div>
  </div>
</div>
